import { OrderStatus } from '../../config/_enums';

export const getOrderFilter = () => {
  return { status: OrderStatus.OPEN }
};
